module.exports = __webpack_public_path__ + "static/media/DSC00205.e1835990.jpg";